"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EIP_712_TYPES = exports.EIP_712_TYPES_STRICT = void 0;
/**
 * `EIP_712_TYPES.<contractName>.<functionName>`
 *
 * Select 2 levels deep. e.g. `EIP_712_TYPES.Worlds.AuthorizeBySignature`. Nested under this is an object which will
 * include the function name again, and may have other types as well.
 *
 * @dev This strict version is used by the Frontend & viem/wagmi.
 */
exports.EIP_712_TYPES_STRICT = {
    Worlds: {
        AuthorizeBySignature: {
            AuthorizeBySignature: [
                { name: "worldId", type: "uint256" },
                { name: "seller", type: "address" },
                { name: "nftContract", type: "address" },
                { name: "nftTokenId", type: "uint256" },
                { name: "takeRateInBasisPoints", type: "uint16" },
                { name: "listingType", type: "uint8" },
                { name: "listingIdentifier", type: "string" },
                { name: "expiration", type: "uint256" },
            ],
        },
    },
};
/**
 * `EIP_712_TYPES.<contractName>.<functionName>`
 *
 * Select 2 levels deep. e.g. `EIP_712_TYPES.Worlds.AuthorizeBySignature`. Nested under this is an object which will
 * include the function name again, and may have other types as well.
 *
 * @dev This non-strict version is used by tests & ethers.
 */
exports.EIP_712_TYPES = exports.EIP_712_TYPES_STRICT;
//# sourceMappingURL=eip712Types.js.map